import fetch from './fetch'

class SystemApi {
	public getList(form: any) {
		return fetch({
			url: 'injury/rule/list',
			method: 'post',
			data: form,
		})
	}

	public enable(form: any) {
		return fetch({
			url: 'injury/rule/enable',
			method: 'post',
			data: form,
		})
	}
}

export default new SystemApi()
